import { query } from './query.js';

function jsonPayload(data) {
    return {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: data ? JSON.stringify(data) : '',
        credentials: 'include',
    };
}

function formPayload(data, method = 'POST') {
    return {
        method,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: data ? query(data) : '',
        credentials: 'include',
    };
}

function get(path, params) {
    return fetch(`${FINN.travel.contextPath}${path}?${params}`)
        .then(response => response.json())
        .catch(error => console.log('Error in GET request', error)); // eslint-disable-line
}

function post(path, payload) {
    return fetch(`${FINN.travel.contextPath}${path}`, payload)
        .then(response => response.json())
        .catch(error => console.log('Error in POST request', error)); // eslint-disable-line
}

export function getLowfare(data) {
    return get('result/lowfare', query(data));
}

export function postSearch(data) {
    return post('search', formPayload(data));
}

export function postJson(path, data) {
    return post(path, jsonPayload(data));
}
